import React, { useContext } from "react";
import { Global } from "../../App";
import { FormattedMessage } from "react-intl";
import { CusSwitch } from "../From/Switch";
import { CusButton } from "../../Components/From/Button";
import Tool_counter from "./Tool_counter";
import cls from "classnames";
import _ from "lodash";
import { getSpecificTasteDisplay } from "../../Lib/specificTaste";
/**
 *
 * @param {object} props
 * @param {boolean} props.showTitle
 * @param {boolean} props.delete
 * @param {string} props.type
 * @param {string} props.device
 * @param {object} props.data
 * @param {()=>data} props.onDelete
 * @param {()=>data} props.onUpdate
 * @param {()=>data} props.onEditTaste
 * @param {()=>data} props.onAddNewSpec
 *
 *
 */

const Tool_mealList = ({
  showTitle = true,
  deleteButton = true,
  modifyButton = true,
  IsShowOrderDetail = false,
  IsMultiLang = false,
  type,
  device,
  data,
  onDelete,
  onUpdate,
  onEditTaste,
  onAddNewSpec,
  onSwitch,
  onModify,
}) => {
  const { globalState } = useContext(Global);

  // if (!data) return null;

  // 鎖菜暫存處理 start
  if (!data) {
    return null;
  } else {
    const { staffInfo } = globalState;
    const orderCode = staffInfo.orderCode;
    if (globalState.Hold && globalState.Hold.orderCode === orderCode) {
      data.specification.map((e) => {
        e.combination.map((e1) => {
          const Data = {
            id: e.id,
            taste: e1.taste,
            takeout: e1.takeout,
            quantity: e1.quantity,
          };
          globalState.Hold.holditems.map((e2) => {
            if (JSON.stringify(e2.productIdcombi) === JSON.stringify(Data)) {
              e1.bIsLock = e2.hold > 0 || e1.bIsLock;
              e1.lockTime = e2.hold;
            }
          });
        });
      });
    }
  }
  // 鎖菜暫存處理 end

  // [外帶]開啟特口選單
  const addTakeoutWithTaste = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: true,
      specPopupSetting: {
        toggle: true,
        productName: data.name,
        specName: specDate.name,
        itemList: data.takeoutTaste,
        selectedItem: data.takeoutTaste
          .filter((f) => f.preset)
          .map((e) => e.id),
      },
      isAddNew: true,
      currModify: {
        productId: data.id,
        specId: specDate.id,
        takeout: true,
        taste: data.takeoutTaste.filter((f) => f.preset).map((e) => e.id),
        quantity: 1,
      },
    });
  };
  // [外帶]直接新增一筆預設特口
  const addTakeoutDefault = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: false,
      currModify: {
        productId: data.id,
        specId: specDate.id,
        takeout: true,
        taste: [],
        quantity: 1,
      },
    });
  };
  // [內用]開啟特口選單
  const addDiningInWithTaste = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: true,
      specPopupSetting: {
        toggle: true,
        productName: data.name,
        specName: specDate.name,
        itemList: data.stayInTaste,
        selectedItem: data.stayInTaste.filter((f) => f.preset).map((e) => e.id),
      },
      isAddNew: true,
      currModify: {
        productId: data.id,
        specId: specDate.id,
        takeout: false,
        taste: data.stayInTaste.filter((f) => f.preset).map((e) => e.id),
        quantity: 1,
      },
    });
  };
  // [內用]直接新增一筆預設特口
  const addDineInDefault = (specDate) => {
    onAddNewSpec({
      hasSpecTaste: false,
      currModify: {
        productId: data.id,
        specId: specDate.id,
        takeout: false,
        taste: [],
        quantity: 1,
      },
    });
  };

  return (
    <>
      <div
        className={cls(
          "specification",
          type === "takeout" ? "specification-dark " : ""
        )}
      >
        {data.specification.map((eachSpec, specIndex) => (
          <div key={specIndex} className=" d-flex">
            <div className={specIndex === 1 ? "w-100 mt-1" : "w-100"}>
              <div className="d-flex align-items-center justify-content-between">
                {/* 外語時的顯示方式 */}
                <div>
                  {(() => {
                    if (specIndex === 0) {
                      if (globalState.langType != "zh" && IsMultiLang) {
                        return (
                          <>
                            <h5 className="textColorPrimary mr-2 pt-2">
                              {data.langName}
                            </h5>
                            <span className="text-base font-bold mr-2 ">
                              {data.name}
                            </span>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <h5 className="textColorPrimary m-0 ">
                              {data.langName}
                            </h5>
                          </>
                        );
                      }
                    }
                  })()}
                </div>
                {/* 一個品項只有第一個規格旁邊顯示修改 */}
                {specIndex === 0 && modifyButton ? (
                  <div className="py-2">
                    <p
                      className={
                        type === "takeout"
                          ? "button-alter bgColorDarkBrown"
                          : "button-alter bgColorBrown"
                      }
                      onClick={() => {
                        onModify();
                      }}
                    >
                      <FormattedMessage id="popup.buttonModify" />
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </div>
              {/* 只有一個規格卻沒特口時 */}
              {eachSpec.combination.length === 1
                ? eachSpec.combination.map((eachCombi, combiIndex) => (
                    <div
                      key={combiIndex}
                      className="w-100 d-flex justify-content-between"
                    >
                      <div className="d-flex text-secondary align-items-center">
                        {/* 沒有特口的時候刪除按鈕在外面 */}
                        {eachSpec.combination[0].taste.length === 0 ? (
                          deleteButton ? (
                            <a
                              className="d-flex p-1 txtColorRed"
                              onClick={() => {
                                let newState = _.cloneDeep(data);
                                newState.specification[
                                  specIndex
                                ].combination.splice(combiIndex, 1);
                                onDelete({
                                  newData: newState,
                                });
                              }}
                            >
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 24 24"
                                fill="none"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M21.2929 1.29289C21.6834 0.902369 22.3166 0.902369 22.7071 1.29289C23.0976 1.68342 23.0976 2.31658 22.7071 2.70711L13.4142 12L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L12 13.4142L2.70711 22.7071C2.31658 23.0976 1.68342 23.0976 1.29289 22.7071C0.902369 22.3166 0.902369 21.6834 1.29289 21.2929L10.5858 12L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L12 10.5858L21.2929 1.29289Z"
                                  fill="#D84E40"
                                />
                              </svg>
                            </a>
                          ) : null
                        ) : (
                          ""
                        )}
                        {/* 規格雙語 */}
                        {eachSpec ? (
                          globalState.langType != "zh" && IsMultiLang ? (
                            <span className="py-1 ">
                              <span className="py-1 font-bold">
                                {eachSpec.name}
                              </span>{" "}
                              {eachSpec.langName}
                            </span>
                          ) : (
                            <span className="py-1">{eachSpec.langName}</span>
                          )
                        ) : (
                          ""
                        )}
                        <span
                          translate="no"
                          className="tool_mealList_breadpy-1 ml-2"
                        >
                          $ {eachSpec.price}
                        </span>
                      </div>
                      <div className="d-flex  mr-2 my-1">
                        {/* 沒有特口的時候價格數量在外面 */}
                        {eachSpec.combination[0].taste.length === 0 ? (
                          <div className="d-flex align-items-center ">
                            {/*鎖菜*/}
                            {globalState.staffInfo.checkOrderData &&
                            globalState.staffInfo.checkOrderData.isAddOrder ? (
                              <div>
                                {eachCombi.bIsLock ? (
                                  <>
                                    <div className="h-100 d-flex">
                                      <span className="h-100 d-flex align-items-center">
                                        {" "}
                                        +{eachCombi.lockTime}
                                      </span>
                                      <span className="pl-1">
                                        <FormattedMessage id="pages.Minute" />
                                      </span>
                                    </div>
                                  </>
                                ) : null}
                              </div>
                            ) : null}
                            {/* 計數器 */}
                            <span className="textColorPrimary mx-3">
                              {eachCombi.quantity}{" "}
                            </span>
                            {/* 單個組合單價 * 數量 */}
                            <span
                              translate="no"
                              className="h-100 d-flex justify-content-end test-secondary min-w-50"
                            >
                              $
                              {(() => {
                                const { takeoutTaste, stayInTaste } = data;
                                let whichTaste = eachCombi.takeout
                                  ? takeoutTaste
                                  : stayInTaste;
                                let price = eachSpec.price;
                                let quantity = eachCombi.quantity;
                                let tastePrice =
                                  whichTaste.length <= 0
                                    ? whichTaste
                                    : eachCombi.taste.map((e) => {
                                        let findTaste = whichTaste.find(
                                          (f) => f.id === e
                                        );
                                        return findTaste.price;
                                      });
                                let combiTastePrice = tastePrice.reduce(
                                  (curr, item) => {
                                    return curr + item;
                                  },
                                  0
                                );
                                return (
                                  price * quantity + combiTastePrice * quantity
                                );
                              })()}
                            </span>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  ))
                : ""}
              {/* 售畢時 */}
              {(eachSpec.status === 3 || eachSpec.status === 4) &&
              !IsShowOrderDetail ? (
                <div className="sold-out">
                  <div className="">
                    <FormattedMessage
                      id={`popup.${
                        eachSpec.status === 3 ? "soldOut" : "suspendSell"
                      }`}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="w-100">
                {/* 有規格時 */}
                {eachSpec.combination.length > 1 ? (
                  <div className="d-flex text-secondary align-items-center">
                    {/* 規格雙語 */}
                    {eachSpec ? (
                      globalState.langType === "zh" ? (
                        <span className="py-1">{eachSpec.langName}</span>
                      ) : (
                        <span className="py-1 ">
                          <span className="py-1 font-bold">
                            {eachSpec.name}
                          </span>{" "}
                          {eachSpec.langName}
                        </span>
                      )
                    ) : (
                      ""
                    )}
                    <span
                      translate="no"
                      className="tool_mealList_breadpy-1 ml-2"
                    >
                      $ {eachSpec.price}
                    </span>
                  </div>
                ) : (
                  ""
                )}
                {eachSpec.combination.map((eachCombi, combiIndex) => (
                  <div key={combiIndex} className="w-100">
                    {eachCombi.taste.length > 0 ||
                    eachSpec.combination.length > 1 ? (
                      <div className="w-100 d-flex  mr-3 my-1">
                        <>
                          {/* 特口顯示條件 1.有不同規格 2.加點時有鎖菜 3.有特口 4.單品項大於1 5.特口數量大於1*/}
                          <div
                            className={
                              type === "takeout"
                                ? "tool_mealList_card card-bg-takeout "
                                : "tool_mealList_card card-bg-dinein"
                            }
                          >
                            <div className="d-flex">
                              {deleteButton ? (
                                <a
                                  className="d-flex txtColorRed"
                                  onClick={() => {
                                    let newState = _.cloneDeep(data);
                                    newState.specification[
                                      specIndex
                                    ].combination.splice(combiIndex, 1);
                                    onDelete({
                                      newData: newState,
                                    });
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="w-5 h-5"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      d="M6 18L18 6M6 6l12 12"
                                    />
                                  </svg>
                                </a>
                              ) : null}
                              {eachCombi.taste.length > 0
                                ? (() => {
                                    return (
                                      <span className="h-100 d-flex flex-wrap align-items-center">
                                        {eachCombi.taste.map(
                                          (taste, tasteIndex) => {
                                            let whichTaste;
                                            if (eachCombi.takeout) {
                                              whichTaste = data.takeoutTaste;
                                            } else {
                                              whichTaste = data.stayInTaste;
                                            }
                                            return whichTaste
                                              .filter((tasteData) => {
                                                return tasteData.id === taste;
                                              })
                                              .map((e, index) => (
                                                <div key={index}>
                                                  {(() => {
                                                    let hasPrice = e.price > 0;
                                                    let isLast =
                                                      eachCombi.taste.length ===
                                                      tasteIndex + 1;
                                                    return (
                                                      <>
                                                        <span>
                                                          {hasPrice
                                                            ? `${e.name}($+${e.price})`
                                                            : getSpecificTasteDisplay(
                                                                e,
                                                                data
                                                              )}
                                                        </span>
                                                        {isLast ? (
                                                          ""
                                                        ) : (
                                                          <span className="mx-1">
                                                            /
                                                          </span>
                                                        )}
                                                      </>
                                                    );
                                                  })()}
                                                </div>
                                              ));
                                          }
                                        )}
                                      </span>
                                    );
                                  })()
                                : ""}
                            </div>
                            <div className="d-flex align-items-center ">
                              {/*鎖菜*/}
                              {globalState.staffInfo.checkOrderData &&
                              globalState.staffInfo.checkOrderData
                                .isAddOrder ? (
                                <div>
                                  {eachCombi.bIsLock ? (
                                    <>
                                      <div className="h-100 d-flex">
                                        <span className="h-100 d-flex align-items-center">
                                          {" "}
                                          +{eachCombi.lockTime}
                                        </span>
                                        <span>
                                          {" "}
                                          <FormattedMessage id="pages.Minute" />
                                        </span>
                                      </div>
                                    </>
                                  ) : null}
                                </div>
                              ) : null}
                              {/* 計數器 */}
                              <span className="textColorPrimary mx-3">
                                {eachCombi.quantity}{" "}
                              </span>
                              {/* 單個組合單價 * 數量 */}
                              <span
                                translate="no"
                                className="h-100 d-flex align-items-center test-secondary "
                              >
                                $
                                {(() => {
                                  const { takeoutTaste, stayInTaste } = data;
                                  let whichTaste = eachCombi.takeout
                                    ? takeoutTaste
                                    : stayInTaste;
                                  let price = eachSpec.price;
                                  let quantity = eachCombi.quantity;
                                  let tastePrice =
                                    whichTaste.length <= 0
                                      ? whichTaste
                                      : eachCombi.taste.map((e) => {
                                          let findTaste = whichTaste.find(
                                            (f) => f.id === e
                                          );
                                          return findTaste.price;
                                        });
                                  let combiTastePrice = tastePrice.reduce(
                                    (curr, item) => {
                                      return curr + item;
                                    },
                                    0
                                  );
                                  return (
                                    price * quantity +
                                    combiTastePrice * quantity
                                  );
                                })()}
                              </span>
                            </div>
                          </div>
                        </>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default Tool_mealList;
